import { login, getCurrMenu, getCurrUser } from '@/api/login'
import { message } from 'ant-design-vue'
export class UserController {
  static async login (params: USER.Params.Login) {
    return await login(params)
  }

  static async getCurrMenu () {
    const { code, data } = await getCurrMenu()
    const _data: any[] = data as any
    if (_data.length === 0) {
      // message.error('暂未分配权限，请联系管理员')
    }
    return _data as unknown as unknown[] as any[]
  }

  static async getCurrUser () {
    const { data } = await getCurrUser()
    return data
  }
}
